/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/button-has-type */
/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { formatCurrency } from '@brazilian-utils/brazilian-utils';
import React, { useEffect } from 'react';
import { useReactToPrint } from "react-to-print";
import { Button, ModalPixPagamento, ButtonCompartilhar, TextSpan, ButtonsDownload } from './styles';

interface ModalPixProps {
  code: string
  line: string
  value: number
  closeModal: () => void
  image: string
}

const ModalTicket: React.FC<ModalPixProps> = ({
  code,
  line,
  value,
  closeModal,
  image,
}) => {

  const componentRef = React.useRef(null);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef?.current]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "TransfacilQRCode",
    removeAfterPrint: false
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ModalPixPagamento>
      <div className="wrapper">
        <button
          className="close"
          type="button"
          aria-label="close"
          onClick={closeModal}
        />
        <div ref={componentRef}>
          <div className="row" style={{ backgroundColor: '#f5f5f5' }}>
            <div style={{ padding: 30 }}>
              <p> <strong> Código QrCode: </strong> {code} </p>
              <p> <strong> Linha: </strong> {line} </p>
              <p> <strong> Valor: </strong> R$ {formatCurrency(value)} </p>
              <img
                src={image}
                alt="ticket image"
                style={{
                  height: '200px',
                  width: '200px',
                  marginTop: '30px',
                }}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: '20px',
            marginBottom: '20px',
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <TextSpan>
            *Esta no celular? Pressione o dedo sobre o QrCode para compartilha-lo para os seus contatos.

          </TextSpan>
        </div>
            <Button onClick={handlePrint}>
              DOWNLOAD
            </Button>
      </div>
    </ModalPixPagamento>
  );
};

export default ModalTicket;
